import { ConnectButton } from "@rainbow-me/rainbowkit"
import { useLocation, useNavigate } from "react-router-dom"
import { Logo } from "../assets"
import { Button } from "./commons"
import { siteMap } from "./commons/constants"
import { Typography } from "@mui/material"
import React from "react"
import ChainSelect from "./commons/ChainSelect"

const NavBar = () => {
  // const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const history = useNavigate()
  const location = useLocation()
  const isDefaultPath = Object.values(siteMap).find((site) => site.path === location.pathname)?.path ?? '/'

  const navigateTo = (route: string) => {
    history(route)
  }

  // const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
  //   setAnchorEl(event.currentTarget);
  // };

  // const handleClose = () => {
  //   setAnchorEl(null);
  // };


  // const open = Boolean(anchorEl);
  return (
    <div style={{
      display: 'grid', color: 'white',
      padding: '1rem 2rem', gridTemplateColumns: 'fit-content(100%) 5fr 2fr',
      alignItems: 'center',
      marginBottom: '4rem',
      gap: '2rem',
    }}>
      <div>
        <Logo style={{ maxWidth: '11rem', cursor: 'pointer' }} onClick={() => navigateTo('/')} />
      </div>
      <div style={{ display: 'flex', gap: '1rem' }}>
        {
          Object.values(siteMap).filter((sites) => sites.display).map(({ path, name }) => {
            return (
              <Button key={name} onClick={() => navigateTo(path)} size='large' variant='text' isSelected={location.pathname === path || isDefaultPath === path} sx={{ border: 0 }}>
                <Typography variant="body2">{name}</Typography>
              </Button>
            )
          })
        }
      </div>
      <div style={{ display: 'flex', gap: '1rem', justifySelf: 'flex-end', alignSelf: 'center' }}>
        <div className="rainbowConnectButton" style={{
          display: 'flex', gap: '1rem',
          justifySelf: 'flex-end',
          alignSelf: 'center',
          maxHeight: '2.5rem',
          minWidth: '30rem',
          justifyContent: 'flex-end'
        }}>
          {/* <Button onClick={handleClick} aria-describedby={"reward-popover"} color="secondary"
            variant='contained' sx={{ minWidth: '5rem', padding: '0rem 0rem', maxHeight: '2.5rem' }}>
            <Grid container alignItems={'center'} justifyItems={'center'}>
              <RewardsIcon />
              <Typography color='brand.primary' component={'span'} sx={{ marginLeft: '0.5rem' }}>
                100
              </Typography>
            </Grid>
          </Button>
          <Popover id={"reward-popover"}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}>
            <Grid sx={{ marginTop: '0.5rem' }}>
              <PointsPopover />
            </Grid>
          </Popover> */}
          <ChainSelect />
          <ConnectButton label="Connect" />
        </div>
      </div>
    </div >
  )
}

export default NavBar